// src/blogs/BlogSceneRoute.jsx
// Thin dispatcher for the three /blog/* scene routes — owns no chrome of its
// own (that's BlogShell, mounted inside each blog).
import React, { useMemo } from "react";

import AudioBlog from "./AudioBlog.jsx";
import MovieBlog from "./MovieBlog.jsx";
import ThoughtsBlog from "./ThoughtsBlog.jsx";
import { BlogNavContext } from "./BlogNavContext.js";

const BLOGS = {
  longer: AudioBlog,
  content: MovieBlog,
  thoughts: ThoughtsBlog,
};

// `onNavigate` is App's veil-covered hop; post links use it (via context) to
// cross from one blog into another.
export default function BlogSceneRoute({ kind, onNavigateHome, onNavigate }) {
  const nav = useMemo(() => ({ veilNavigate: onNavigate ?? null }), [onNavigate]);
  const Blog = BLOGS[kind];
  if (!Blog) return null;
  return (
    <BlogNavContext.Provider value={nav}>
      <Blog onNavigateHome={onNavigateHome} />
    </BlogNavContext.Provider>
  );
}
